export default function EFArrowRight({ color }: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="MH100详情" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MH100详情-字号调整" transform="translate(-1143.000000, -20687.000000)" fill={color}>
                    <g id="编组-12" transform="translate(460.000000, 15433.000000)">
                        <g id="编组-40备份" transform="translate(10.000000, 4874.000000)">
                            <g id="编组-31" transform="translate(560.000000, 154.000000)">
                                <g id="编组-23" transform="translate(0.000000, 213.000000)">
                                    <g id="编组-25" transform="translate(25.000000, 5.000000)">
                                        <path
                                            d="M90.6736364,15 L95.2114194,19.5793266 C95.3781633,19.7475969 95.4615385,19.951922 95.4615385,20.1923077 C95.4615385,20.4326935 95.3781633,20.6370184 95.2114194,20.8052885 C95.0446756,20.9735585 94.8422061,21.0576923 94.6040011,21.0576923 C94.3657961,21.0576923 94.1633246,20.9735585 93.9965814,20.8052885 L88.8156458,15.5769231 C88.4345176,15.1923059 88.4464276,14.7956749 88.8513764,14.3870176 L93.9965814,9.19470989 C94.1633246,9.02643956 94.3657961,8.94230769 94.6040011,8.94230769 C94.8422061,8.94230769 95.0446756,9.02643956 95.2114194,9.19470989 C95.3781633,9.36298022 95.4615385,9.5673033 95.4615385,9.80769231 C95.4615385,10.0480813 95.3781633,10.2524044 95.2114194,10.4206747 L90.6736364,15 Z"
                                            id="Fill-1"
                                            transform="translate(92.000000, 15.000000) scale(-1, 1) translate(-92.000000, -15.000000) "
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
